import { offerMeteredTransforms } from "@stores/config/utils";
import { AddOnCard } from "@addons/components/AddOnCard";
import { SwitchToMeteredTransformsCTA } from "@addons/components/SwitchToMeteredTransformsCTA";
import { LegacyTransformsManageLink } from "@addons/components/LegacyTransformsManageLink";
import { useAddOnContext } from "../hooks";
import { IAddOnSlotProps, IFlatAddOnDescriptor } from "../types";
import { subscribedBaseFee, transformsTitle } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IFlatAddOnDescriptor>) {
  const { isCloudHosted, subscribed } = ctx;
  const meteredOffered = offerMeteredTransforms(ctx.config);
  const metered = useAddOnContext("transforms-advanced-metered");

  return (
    <AddOnCard
      isYearly={ctx.isYearly}
      productType="transforms-advanced"
      title={transformsTitle(isCloudHosted)}
      detail={isCloudHosted && subscribed ? "Advanced" : null}
      price={subscribedBaseFee(ctx)}
      // self-hosted keeps its copy even once metered is on offer
      description={
        isCloudHosted
          ? !meteredOffered &&
            "Clean up and model your data right from within Metabase."
          : "Run Python-based transforms alongside SQL to handle more complex logic and data workflows."
      }
      usage={
        meteredOffered && (
          <SwitchToMeteredTransformsCTA legacy={ctx} metered={metered} />
        )
      }
      extra={<LegacyTransformsManageLink addOn={ctx} />}
    />
  );
}
